import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';

import { RsaService } from '../../common_services/encryptutil.service';
import { SecureStorageService } from '../../secure-storage.service';
import { ConfigProvider } from '../../shared/services/configprovider';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { ProviderOutreachService } from './provider-outreach.service';

// declare var $: any;
// declare var jQuery: any;
import { Modal } from 'bootstrap';

@Component({
    selector: 'app-provider-outreach',
    templateUrl: './provider-outreach.component.html',
    styleUrls: ['./provider-outreach.component.scss'],
    standalone: false
})
export class ProviderOutreachComponent implements OnInit , OnDestroy{
  providerData: any[];
  showSpinner = false;
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  sites = [];
  showView: boolean;
  siteProviderConfig: any;
  providerId: any;
  name: any;
  campaignId = 0;
  instanceId = 0;
  mode = 5;
  recall: boolean = false;
  list: any[] = [];
  activeList = [];
  historyList = [];
  selectedFilter = 'Active';
  loading = false;
  p: number = 1;
  searchInput: string;
  data = [];
  selectedStatus: string = 'All';
  allStatusList = [];
  expiredStatusList = [];
  completedStatusList = [];
  pendingStatusList = [];
  otherStatusList = [];
  totalProviderIds = [];
  copyOfList: any[] = [];
  pdmInterval;
  handleResults(searchObj) {
    this.data = searchObj;
  }
  constructor(
    private cupService: CupService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlconstantsService: UrlconstantsService,
    private pdmDataOldService: ProviderOutreachService,
    private secureStorage: SecureStorageService,
    private encryptUtil: RsaService,
    private configProvider: ConfigProvider
  ) {}
  
  ngOnDestroy() {
    if(this.pdmInterval){
      clearInterval(this.pdmInterval);
    }
  }
  ngOnInit() {
    this.getProviderInfo();
  }

  async getProviderInfo() {
    this.totalProviderIds = [];
    let checkResp;
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.userSiteProviders.replace('{id}', username);
    this.showSpinner = true;
    this.list = [];
    this.activeList = [];
    this.historyList;
    let duplicates = [];
    let providerIds = [];

    this.cupService.retrieveData('post', url).subscribe((data) => {
      if (data != null) {
        let observables = [];
        data.forEach((element) => {
          if (element.providers && element.providers.length > 0) {
            element.providers.forEach((each) => {
              if (!duplicates.includes(each.npi) && each.npi !== 'NOTNEEDED') {
                duplicates.push(each.npi);
                providerIds.push(each.providerId);
                
              }
            });
          }
        });
        this.totalProviderIds = providerIds;
        observables.push(
          this.pdmDataOldService.getAddress(providerIds)
        );
        forkJoin(observables).subscribe(
          (responses) => {
            responses.forEach((checkResp) => {
              if (Array.isArray(checkResp)) {
                checkResp.forEach((resp) => {
                  if (resp != undefined) {
                    let outreachExpiredDate = new Date(
                      resp.OutreachExpiredDate
                    );
                    if (outreachExpiredDate >= new Date()) {
                      this.activeList.push(resp);
                    } else {
                      this.historyList.push(resp);
                    }
                  }
                });
                if(this.pdmInterval){
                  clearInterval(this.pdmInterval);
                }
                this.pdmInterval =setInterval(() => {
                  this.triggerPDMDataRefresh();
                }, 10000);
              }
            });

            this.filterData();
            this.showView = true;
            this.showSpinner = false;
          },
          (error) => {
            this.showSpinner = false;
            this.openModal('warningModal');
          }
        );
      }
    });
  }

  triggerPDMDataRefresh(){
    this.activeList = [];
    this.historyList = [];
    this.pdmDataOldService.getPdmData(this.totalProviderIds).subscribe((data) => {
      if (Array.isArray(data)) {
        data.forEach((resp) => {
          if (resp != undefined) {
            let outreachExpiredDate = new Date(
              resp.OutreachExpiredDate
            );
            if (outreachExpiredDate >= new Date()) {
              this.activeList.push(resp);
            } else {
              this.historyList.push(resp);
            }
          }
        });
        this.filterData();
      }
      if(this.pdmInterval){
        clearInterval(this.pdmInterval);
      }
      this.pdmInterval =setInterval(() => {
        this.triggerPDMDataRefresh();
      }, 10000);
    },err=>{
      if(this.pdmInterval){
        clearInterval(this.pdmInterval);
      }
      this.pdmInterval =setInterval(() => {
        this.triggerPDMDataRefresh();
      }, 10000);
    });
  }
  changeSelectedFilter(newFilter) {
    this.selectedFilter = newFilter;
    this.selectedStatus = 'All'; // Reset selectedStatus when selectedFilter changes
    this.filterData();
  }

  filterData() {
    if (this.selectedFilter === 'Active') {
      this.list = this.activeList;
    } else if (this.selectedFilter === 'History') {
      this.list = this.historyList;
    } else if (this.selectedFilter === 'All') {
      this.list = [...this.activeList, ...this.historyList];
    }

    //descending order based on outreach start date
    this.list.sort((a, b) => {
      const dateA = new Date(a.OutreachStartDate);
      const dateB = new Date(b.OutreachStartDate);

      return dateB.getTime() - dateA.getTime();
    });
  }

  filterByStatus() {
    this.filterData();
    if (this.selectedStatus === 'All') {
      this.list = this.list;
    } else if (this.selectedStatus == 'Saved and Awaiting submission') {
      this.list = this.list.filter((element) => {
        return element.Outreachstatus === 'Saved and Awaiting submission';
      });
    } else if (this.selectedStatus == 'Declined') {
      this.list = this.list.filter((element) => {
        return element.Outreachstatus === 'Declined';
      });
    } else if (this.selectedStatus == 'Response submitted') {
      this.list = this.list.filter((element) => {
        return element.Outreachstatus === 'Response submitted';
      });
    } else if (this.selectedStatus === 'Expired') {
      this.list = this.list.filter((element) => {
        return element.Outreachstatus === 'Expired';
      });
    } else if (this.selectedStatus === 'Completed') {
      this.list = this.list.filter((element) => {
        return element.Outreachstatus === 'Completed';
      });
    } else if (this.selectedStatus === 'Pending') {
      this.list = this.list.filter((element) => {
        return element.Outreachstatus === 'Pending';
      });
    }
  }

  dataFilter() {
    this.list = this.copyOfList.filter((element) => {
      if (
        element.data.name
          .toUpperCase()
          .includes(this.searchInput.toUpperCase()) ||
        element.data.npi.includes(this.searchInput)
      ) {
        return element;
      }
    });
  }
  filterMember(event: any) {
    this.dataFilter();
    const filterItems = document.querySelectorAll('.providerDataTable tr').length;
    //console.log('this.searchInput ',this.searchInput);
    const paginationTabs = document.querySelectorAll('.paginationTab');
    if (filterItems < 10 && this.searchInput) {
      paginationTabs.forEach(tab => {
        (tab as HTMLElement).style.display = 'none';
      });
    } else {
      paginationTabs.forEach(tab => {
        (tab as HTMLElement).style.display = 'block';
      });
    }
  }

  rowSelection(providerInfo) {
    let outreachID = providerInfo.OutreachID.toString();
    outreachID = this.encryptUtil.aesencryptForStore(outreachID);
    // URL encode the outreachID
    outreachID = encodeURIComponent(outreachID);
    if (providerInfo.IsEditable === 1 || providerInfo?.IsViewable === 1) {
      let url = '../PODS/#/providerdataupdate/' + outreachID;
      window.open(url, '_blank');
    } else {
      return;
    }
  }
  //   viewMore(providerInfo, event?: any){
  //      if(((event &&(event.target.outerHTML.includes('primaryaddress'))) || (!((event &&(event.target.outerHTML.includes('forExpand')))|| (event &&(event.target.outerHTML.includes('forCollapse'))))))){
  //     let url= 'https://providerportal-tst.caremore.com:6443/#/providerdataupdate/' + this.campaignId + '/'+this.instanceId + '/'+ providerInfo.data.providerId + '/' +this.mode + '/'+ this.recall;
  //     window.open(url,'_blank');

  //   } else {
  //     providerInfo['expand'];
  //     }
  // }
  openModal(modalId: string) {
    const modal =new Modal( document.getElementById(modalId));
  }
}
